import styles from 'css/src/exports.module.scss';

import React from 'react';

import SlideMarker from 'js/src/components/common/video-preview/SlideMarker';

type Props = {
    slideStartTimes: Array<number>;
    slideEndTimes: Array<number>;
    slideIdsByStartTime: Map<number, string>;
    numOpenCommentsPerScene?: Immutable.Map<string, number>;
    duration: number;
    seek: (time: number) => void;
    commentMarkerCallback?: (time: number, forceCommentingMode: boolean) => void;
};

const SlideMarkerScrubber = ({
    slideStartTimes,
    slideEndTimes,
    slideIdsByStartTime,
    numOpenCommentsPerScene,
    duration,
    seek,
    commentMarkerCallback,
}: Props) => {
    const [totalWidth, setTotalWidth] = React.useState(0);
    const scrubberRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const currentScrubberElement = scrubberRef.current;
        if (!currentScrubberElement) {
            return;
        }
        const observer = new ResizeObserver((entries) => {
            if (entries.length > 0) {
                setTotalWidth(entries[0].contentRect.width);
            }
        });
        observer.observe(currentScrubberElement);

        return () => {
            observer.unobserve(currentScrubberElement);
        };
    }, []);

    let slide_marker_nodes: React.ReactNode[] = [];
    if (totalWidth > 0) {
        slide_marker_nodes = slideStartTimes.map((slideStartTime, index) => {
            if (duration <= 0) {
                return null;
            }
            let sceneDurationWithoutTransition;
            if (index + 1 < slideStartTimes.length) {
                sceneDurationWithoutTransition = slideStartTimes[index + 1] - slideStartTime;
            } else {
                sceneDurationWithoutTransition = slideEndTimes[index] - slideStartTime;
            }

            const numComments =
                numOpenCommentsPerScene &&
                numOpenCommentsPerScene.get(slideIdsByStartTime.get(slideStartTime)!);
            const exactWidthPercentage = sceneDurationWithoutTransition / duration;
            const exactWidthPixels = exactWidthPercentage * totalWidth;
            const slideMarkerBorderWidth = parseFloat(styles['slide-marker-border-width']) * 2; // multiply by two because there is a left and right border
            if (exactWidthPixels < slideMarkerBorderWidth) {
                // the width of this slide is not enough to contain the width that would be taken up by just
                // the SlideMarker borders. In this case, we should just not show any SlideMarker.
                return;
            }
            const style = {
                width: `${exactWidthPixels}px`,
            };
            return (
                <SlideMarker
                    numComments={numComments}
                    key={index}
                    style={style}
                    seek={seek}
                    commentMarkerCallback={commentMarkerCallback}
                    new_time={slideStartTime}
                    scene_duration={sceneDurationWithoutTransition}
                />
            );
        });
    }
    return (
        <div
            className="col-sm-12 slide-markers slide-meta-overlay slide-marker-scrubber"
            ref={scrubberRef}
        >
            {slide_marker_nodes}
        </div>
    );
};

export default SlideMarkerScrubber;
